import { DocumentType } from "encamp-prisma/generated/browser";

import { prettyPrintEnumValue } from "./prettyPrintEnumValue";

const documentTypeMap: Record<DocumentType, string> = {
  ASTDocumentation: "AST Documentation",
  Certification: "Certification",
  Check: "Check",
  CoverLetter: "Cover Letter",
  DikeDescription: "Dike Description",
  EmergencyResponsePlan: "Emergency Response Plan",
  EPCRA302: "EPCRA 302",
  EPCRA304: "EPCRA 304",
  EPCRA311: "EPCRA 311",
  EPCRA312: "EPCRA 312",
  EPCRA313: "EPCRA 313",
  FeeCalculation: "Fee Calculation",
  Fees: "Fees",
  Form: "Form",
  HazardousMaterialsContingencyPlanOrQuickGuide:
    "Hazardous Materials Contingency Plan or Quick Guide",
  HazardousMaterialsInventoryStatement: "Hazardous Materials Inventory Statement",
  HazardousMaterialsManagementPlan: "Hazardous Materials Management Plan",
  HazardousWasteAnnualReport: "Hazardous Waste Annual Report",
  HazardousWasteBiennialReport: "Hazardous Waste Biennial Report",
  HazardousWasteContainerLabel: "Hazardous Waste Container Label",
  HazardousWasteContingencyPlan: "Hazardous Waste Contingency Plan",
  HazardousWasteFeesReceipts: "Hazardous Waste Fees/Receipts",
  HazardousWasteNotification: "Hazardous Waste Notification",
  HazardousWasteQuarterlyReport: "Hazardous Waste Quarterly Report",
  HazardousWasteRecertification: "Hazardous Waste Recertification",
  Invoice: "Invoice",
  NegativeDeclaration: "Negative Declaration",
  Other: "Other",
  OtherRCRA: "Other RCRA report",
  P2Plan: "P2 Plan",
  P2Update: "P2 Update",
  Permit: "Permit",
  Proof: "Proof",
  RCRAAnnual: "RCRA Annual",
  RCRAFeePaymentOrInvoice: "RCRA Fee Payment/Invoice",
  RCRAManifest: "RCRA Manifest",
  RCRAManifestPrintedCopy: "RCRAInfo Manifest Printed Copy",
  RCRAUpdateNotification: "RCRA Update Notification",
  Receipt: "Receipt",
  ReferenceImage: "Reference Image",
  Report: "Report",
  RevisionOrUpdate: "Revision/Update",
  SafeguardMeasures: "Safeguard Measures",
  SafetyDataSheet: "Safety Data Sheet",
  Screenshot: "Screenshot",
  SiteCoordinateAbbreviation: "Site Coordinate Abbreviation",
  SpillPreventionControlAndCountermeasurePlan:
    "Spill Prevention, Control, and Countermeasure (SPCC) Plan",
  SitePlan: "Site Plan",
  Submission: "Submission",
  Tier2Submit: "Tier II Submit",
  TrainingPlan: "Training Plan",
  USTDocumentation: "UST Documentation",
  USTMonitoringSitePlan: "UST Monitoring Site Plan",
  USTCertificationOfFinancialResponsibility: "UST Certification of Financial Responsibility",
  USTResponsePlan: "UST Response Plan",
  USTOwnerOperatorWrittenAgreement: "UST Owner/Operator: Written Agreement",
  USTLetterFromChiefFinancialOfficer: "UST Letter from Chief Financial Officer",
  OwnerStatementOfDesignatedUSTOperatorCompliance:
    "Owner Statement of Designated UST Operator Compliance",
  RecyclableMaterialsReportDocumentation: "Recyclable Materials Report Documentation",
  HazardousWasteTankClosureCertificate: "Hazardous Waste Tank Closure Certificate",
  AboveGroundPetroleumStorageActDocumentation: "Above Ground Petroleum Storage Act Documentation",
  AboveGroundSeparationContainmentAndMonitoringPlan:
    "Above Ground Separation, Containment, and Monitoring Plan",
  WasteTransporterContactProof: "Waste Transporter Contact Proof",
  WasteExceptionReportProof: "Waste Exception Report Proof",
  WasteShippingDocument: "Waste Shipping Document",
  WasteStreamProfile: "Waste Stream Profile",
  WasteStreamProfileSummary: "Waste Stream Profile Summary",
  LocalInformationDocument: "Local Information Document",
  AirPermit: "Air Permit",
  AirPermitApplication: "Air Permit Application",
  PermitApprovalLetter: "Permit Approval Letter",
  StormwaterPollutionPreventionPlan: "Stormwater Pollution Prevention Plan (SWPPP)",
  NPDESPermit: "NPDES Permit",
  InspectionFormsOrReports: "Inspection Forms/Reports",
  OperationsAndMaintenancePlan: "Operations & Maintenance (O&M) Plan",
  EvacuationMap: "Evacuation Map",
  MusterMap: "Muster Map",
  SecurityLayout: "Security Layout",
  LocationPlan: "Location Plan",
  HazardousWasteCompliancePlan: "Hazardous Waste Compliance Plan (HWCP)",
  ConfinedFeedingOperationPermit: "Confined Feeding Operation Permit",
  WastewaterOrStormwaterAnalyticalResults: "Wastewater/Stormwater Analytical Results",
  WaterSamplingLabReport: "Water Sampling Lab Report",
  GroundwaterMonitoringData: "Groundwater Monitoring Data",
  FieldSamplingFormOrLogbook: "Field Sampling Form/Logbook",
  AirPermitEmissionsTable: "Air Permit Emissions Table (MAERT)",
  CEMSData: "CEMS Data",
  RemediationReportOrDocument: "Remediation Report/Document",
  TankClosureSiteAssessment: "Tank Closure Site Assessment",
  BrownfieldsPostClosureObligation: "Brownfields Post-Closure Obligation",
  SamplingPlan: "Sampling Plan",
  StandardOperatingProcedure: "Standard Operating Procedure (SOP)",
  EPADataElementDictionary: "EPA Data Element Dictionary",
  EPACopyOfRecord: "EPA Copy of Record",
  RegulatorCommunicationRecord: "Regulator Communication Record",
  StateEnvironmentalRegulation: "State Environmental Regulation",
  NoticeOfViolation: "Notice of Violation",
  RegulatoryInspectionFindings: "Regulatory Inspection Findings",
  WasteNoticeOfRegistration: "Waste Notice of Registration",
};

export function prettyPrintDocumentType(documentType: DocumentType | null | undefined): string {
  if (!documentType) return "";

  // Return the mapped value if it exists, otherwise use prettyPrintEnumValue
  return documentTypeMap[documentType] || prettyPrintEnumValue(documentType);
}
